import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppContext } from '@contexts/AppContext';
import { useQuery } from '@tanstack/react-query';
import { redirectCsrCreatedUser } from '@utils';
import { getProfile, service } from 'sdk-apogee';

const useHandleRedirect = (isCaptivePortal = false) => {
  const history = useHistory();
  const { saveUser, setIsAuthenticated, portalAccessUrl } = useAppContext();
  const { refetch } = useQuery({
    queryKey: ['profile'],
    queryFn: getProfile,
    enabled: false,
    retry: (_, error: any) => error.status !== 401,
    throwOnError: false,
  });

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get('jwt');
    const newUser = urlParams.get('new_user');
    const username = urlParams.get('username');
    const first = urlParams.get('first');
    const last = urlParams.get('last');
    const email = urlParams.get('email');
    const group = urlParams.get('group');
    const phone = urlParams.get('phone');

    if (token && newUser) {
      return history.push({
        pathname: portalAccessUrl('/complete-profile', isCaptivePortal),
        state: { data: { email, username, first, last, group, phone } },
      });
    }

    redirectCsrCreatedUser(queryString, history);

    if (token) {
      setIsAuthenticated(true);

      service.interceptors.request.use((config: any) => {
        return {
          ...config,
          headers: {
            ...config.headers,
            Authorization: `Bearer ${token}`,
          },
        };
      });

      refetch().then(({ data }) => saveUser(data));

      localStorage.setItem('token', token);
      if (!isCaptivePortal) {
        history.push('/home');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useHandleRedirect;
